import { action }         from 'mobx';
import { makeObservable } from 'mobx';
import { observable }     from 'mobx';

export type PlacePanelLevel = 'place' | 'style';

export class PlacePanelStore {
	@observable level: PlacePanelLevel = 'place';

	constructor() {
		makeObservable(this);
	}

	@action setLevel(level: PlacePanelLevel) {
		this.level = level;
	}
}

export default new PlacePanelStore();
